<script lang="ts">
  import type { BaseDuration } from 'shared/definitions/musicTheory/rhythms';
  import Button from '../../../website/src/lib/components/Button.svelte';
  import ButtonGroup from '../../../website/src/lib/components/ButtonGroup.svelte';
  // import DivButton from '../../../website/src/lib/components/DivButton.svelte';
  // import RadioButton from '../../../website/src/lib/components/RadioButton.svelte';
  // import ToggleButton from '../../../website/src/lib/components/ToggleButton.svelte';
  import RhythmSpan from '../uTheory.Notation/RhythmSpan.svelte';
  import { createEventDispatcher } from 'svelte';
  import type { ButtonColor } from '../../../website/src/lib/components/ButtonDefinitions';

  export let disabled = false;
  export let rhythms: BaseDuration[] = ['w', 'h', 'q', '8', '16'];
  export let rests: BaseDuration[] = ['w', 'h', 'q', '8', '16'];

  export let showDot = true;
  export let dotDisabled = false;

  export let suppressBreakBeforeRests = false;
  export let textColor = 'white';
  export let buttonColor: ButtonColor = 'orange';
  let clazz = '';
  export { clazz as class };

  /**
   * When in a situation where a dot cannot be added to the rhythm, this
   * adds a disabled state on the dot button.
   */

  $: breakBeforeRests =
    rhythms.length &&
    rests.length &&
    rhythms.length + rests.length > 8 &&
    !suppressBreakBeforeRests;

  const dispatch = createEventDispatcher();
</script>

<ButtonGroup class={clazz}>
  {#each rhythms as rhythm}
    <Button
      {disabled}
      class="text-2xl"
      color={buttonColor}
      on:click={() => dispatch('click', rhythm)}
    >
      <RhythmSpan color={textColor} rhythmString={`4/2: ${rhythm}`} />
    </Button>
  {/each}
  {#if breakBeforeRests}
    <div class="w-full h-0" />
  {/if}
  {#each rests as rest}
    <Button
      {disabled}
      class="text-2xl"
      color={buttonColor}
      on:click={() => dispatch('click', rest + 'r')}
    >
      <RhythmSpan color={textColor} rhythmString={`4/2: ${rest}r`} />
    </Button>
  {/each}
  {#if showDot}
    <Button
      color={buttonColor}
      disabled={dotDisabled || disabled}
      on:click={() => dispatch('click', '.')}
    >
      <span style="color: {textColor};">.</span>
    </Button>
  {/if}
  <slot />
</ButtonGroup>
